
export class DespesasFundoFixo {
  numTransacao: string;
  tipoTransacao: string;
  contaContabil: string;
  nomeTransacao: string;
}